import React from 'react'
import logo from "../assets/footer-logo.webp"
import Slider from "react-slick";
import img1 from "../assets/Ad-1.webp"
import img2 from "../assets/Ad-2.webp"
import img3 from "../assets/Ad-3.webp"
import img4 from "../assets/Ad-4.webp"
import Carousel from './Carousel';
import { useNavigate } from 'react-router-dom';


const Advertisement = () => {

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // autoplay: true,
    // autoplaySpeed: 2000,
  };


  const settings2 = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    // autoplay: true,
    // autoplaySpeed: 20,
  };

  const navigate =  useNavigate()

  const handleClick = (data) =>{
    localStorage.setItem('nav',data)
    window.scrollTo(0,200)
    navigate("/project")
  }

  return (
    <div >
          <div className='px-20' id='ad'>
          <div className='border-l-2 mr-12 ml-28 ' id='ad-div'>
            <div className='flex items-center'>
             <img className='pl-8 w-56' src={logo} id='ad-logo' alt='vwrap'/> 
             <h2 className='border-l-0' >360 ADVERTISEMENT </h2><br/>
            </div>
             <h2 style={{color:"#FBC213"}} className=' border-l-0'>SERVICES</h2>
            </div>
          </div>

     <div id='carousel' className=' justify-center'>
        <Carousel />
     </div>

     <div id='carousel-2' className='flex justify-center'>
     <div id='carousel-2-sec' className='w-2/4 my-8 mb-12'>
        <Slider {...settings}>
          <div className='slide-1'>
          <div>
          <p
           style={{cursor:"pointer"}}
           onClick={()=> handleClick("ALL")}>
                <p className='color-theme' style={{margin:'0',paddingTop:'0'}}>360 ADVERTISEMENT PLANING</p>
                <span style={{marginTop:'0'}}>360°Marketing Campaign is a complete creative campaign idea across allthe brand’s marketing</span>
              </p>
          </div>
          </div>
          <div  className='slide-2'>
          <div>
          <p
           style={{cursor:"pointer"}}
           onClick={()=> handleClick("CAR")}>
                <p style={{margin:'0',paddingTop:'0'}}>ON VEHICLE ADVERTISEMENT PLATFORM PROVIDER</p>
                <span style={{marginTop:'0'}}>Vwrap takes brands street to street to cover every possible corner of the city so it’s message is seen</span>
              </p>
          
          </div>
          </div>
          <div  className='slide-3'>
          <div>
          <p
           style={{cursor:"pointer"}}
           onClick={()=> handleClick("BILLBOARDS")}>
                <p style={{margin:'0',paddingTop:'0'}} className='color-theme'>OUT OF HOME ADVERTISEMENT PLATFORM PROVIDER</p>
                <span style={{marginTop:'0'}}>Vwrap is a promising advertisement agency, established with an aim to provide effective quality out of home</span>
              </p>
          </div>
          </div>
          
        </Slider>
      </div>
     </div>

     <div className='flex justify-center'>
     <p id='about-btn'>Learn More</p>
     </div>

      <div id='ad-images' className='flex my-40'>
      
        <img width={"30%"} src={img1} alt='vwrap' />
        <img width={"30%"} src={img2} alt='vwrap' />
        <img width={"30%"} src={img3} alt='vwrap' />
        <img width={"30%"} src={img4} alt='vwrap' />
        <img id='animated-img' width={"30%"} src={img1} alt='vwrap' />
        <img id='animated-img' width={"30%"} src={img2} alt='vwrap' />
        <img id='animated-img' width={"30%"} src={img3} alt='vwrap' />
        <img id='animated-img' width={"30%"} src={img4} alt='vwrap' />
     
      </div>

      <div id='ad-carousel' >
      <div className='w-9/12 my-8'>
        <Slider {...settings}>
          <div>
          <img src={img1} alt='vwrap'/>
          </div>
          <div>
          <img src={img2} alt='vwrap'/>
          </div>
          <div>
          <img src={img3} alt='vwrap'/>
          </div>
          <div>
          <img src={img4} alt='vwrap'/>
          </div>
          
        </Slider>
      </div>
      </div>

    </div>
  )
}

export default Advertisement
